// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC4iNucN4KWYkod8yCa9MUnUMpPIDcz6X0",
  authDomain: "portfolionom.firebaseapp.com",
  projectId: "portfolionom",
  storageBucket: "portfolionom.appspot.com",
  messagingSenderId: "914957502716",
  appId: "1:914957502716:web:bc0dcc345d86ca3c6b2f79"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;